import React from 'react';
import { ContentSection } from '@vwfs-bronson/bronson-react';
import { HeroImage } from '@cp-shared-19/frontend-ui';
import { SimplePage, SimpleTeaser, SimplePageContent } from '@cp-mx/common';

export const PrivacyPolicyTeaserUI: React.FC<{ teaser?: SimpleTeaser }> = ({ teaser }) =>
    teaser ? (
        <HeroImage
            title={teaser.title}
            imageUrl={teaser.imageUrl}
            shallow={true}
            inverted={!!teaser.isInverted}
            subTitle={teaser.subTitle}
        />
    ) : null;

export const PrivacyPolicyContent: React.FC<{ content?: SimplePageContent }> = ({ content }) =>
    content ? (
        <>
            {Object.keys(content).map((section: string) => (
                <ContentSection key={section} pageWrapSize="medium">
                    <div dangerouslySetInnerHTML={{ __html: content[section] }} />
                </ContentSection>
            ))}
        </>
    ) : null;

export const PrivacyPolicyUi: React.FC<{ privacyPolicy?: SimplePage }> = ({ privacyPolicy }) =>
    privacyPolicy ? (
        <>
            <PrivacyPolicyTeaserUI teaser={privacyPolicy.teaser} />
            <PrivacyPolicyContent content={privacyPolicy.content} />
        </>
    ) : null;
